module.exports = __webpack_public_path__ + "img/google-wallet.ad735344.png";